import {mapValues} from 'lodash';

import {
  KeyboardActionEventHandler,
  KeyboardEventHandlers,
} from '../../libs/shared/ui/src/components/keyboard/keyboardContext';

/*
 * Helpers.
 */

export function handlerWithTextInputIntent(handler: KeyboardActionEventHandler): KeyboardActionEventHandler {
  return (event, actionEvent) => {
    actionEvent.suspendActionsForTextInputIntent();
    handler(event, actionEvent);
  };
}

export function handlersWithTextInputIntent(handlers: KeyboardEventHandlers): KeyboardEventHandlers {
  return mapValues(handlers, handlerWithTextInputIntent);
}
